import React from "react";

import { TextAreaWithMentions } from "@mapmycustomers/ui";

import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";
import { TEXT_LENGTH_LIMIT } from "@app/util/consts";

import styles from "./TextField.module.scss";

const TextField = ({ entity, field }: RegistryProps) => {
  const value = field.getValueFor(entity) as string;

  return (
    <TextAreaWithMentions
      allUsers={[]}
      className={styles.field}
      disableMentions
      isTextField
      maxLength={TEXT_LENGTH_LIMIT}
      readOnly
      teams={[]}
      value={value}
    />
  );
};

export default TextField;
